import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  updateDoc,
  orderBy,
  startAfter,
  getCountFromServer,
  where,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "predictors", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getPredictors = async (last, filters = {}) => {
  try {
    // Build the base query
    let q = query(
      collection(db, "predictors"),
      orderBy("createdAt", "desc"),
      ...(last ? [startAfter(last)] : []),
      limit(10),
    );

    // Conditionally add filter clauses
    if (!!filters.categories?.length) {
      q = query(
        q,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const predictors = documentSnapshots.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    // Build the query for the total count
    let queryCount = query(
      collection(db, "predictors"),
      orderBy("createdAt", "desc"),
    );

    if (!!filters.categories?.length) {
      queryCount = query(
        queryCount,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    const countSnapshot = await getCountFromServer(queryCount);
    const totalPredictorsCount = countSnapshot.data().count;

    // Return predictors, last document, and total count of predictors
    return { predictors, last: lastVisible, totalPredictorsCount };
  } catch (error) {
    console.error(`Error while getting predictors: ${error}`);
    return error;
  }
};

export const getPredictorById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const predictor = docSnap.data();
  return docSnap.exists
    ? { id: docSnap.id, ...predictor, category: [], reviewers: [] }
    : null;
};

export const updatePredictors = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating predictor ${e}`);
    return false;
  }
};
